const serviceapi = [
    {
        id:1,
        logo: 'fas fa-download',
        title: 'Register for free',
        info: 'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Reiciendis quos debitis amet consequatur nesciunt eius, illum voluptatibus doloribus pariatur, praesentium id dolore corporis suscipit, esse aliquid voluptate voluptas ut vel!',
    },
    {
        id:2,
        logo: 'fas fa-user-check',
        title: 'Verify your identity',
        info: 'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Reiciendis quos debitis amet consequatur nesciunt eius, illum voluptatibus doloribus pariatur, praesentium id dolore corporis suscipit, esse aliquid voluptate voluptas ut vel!',
    },
    {
        id:3,
        logo: 'fas fa-money-check-alt',
        title: 'Add recipients bank details',
        info: 'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Reiciendis quos debitis amet consequatur nesciunt eius, illum voluptatibus doloribus pariatur, praesentium id dolore corporis suscipit, esse aliquid voluptate voluptas ut vel!',
    },
    {
        id:4,
        logo: 'fas fa-amazon-pay',
        title: 'Pay for your transfer',
        info: 'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Reiciendis quos debitis amet consequatur nesciunt eius, illum voluptatibus doloribus pariatur, praesentium id dolore corporis suscipit, esse aliquid voluptate voluptas ut vel!',
    },
    {
        id:5,
        logo: 'fas fa-hand-holding-usd',
        title: 'Choose an amount to send',
        info: 'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Reiciendis quos debitis amet consequatur nesciunt eius, illum voluptatibus doloribus pariatur, praesentium id dolore corporis suscipit, esse aliquid voluptate voluptas ut vel!',
    },
    {
        id:6,
        logo: 'fas fa-globe',
        title: 'Thats it.',
        info: 'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Reiciendis quos debitis amet consequatur nesciunt eius, illum voluptatibus doloribus pariatur, praesentium id dolore corporis suscipit, esse aliquid voluptate voluptas ut vel!',
    },
];

export default serviceapi;